import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAllTags } from "../containers/Tags/service/tags.service";
import { setTagsList } from "../containers/Tags/redux/actions";

const useTags = () => {
  const dispatch = useDispatch();
  const tagList = useSelector((state) => state.tagsReducer.tagsList);
  const menusList = useSelector((state) => state.menuReducer.menuList);
  const [tagsListArray, setTagsListArray] = useState([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        if (tagList?.length > 0) {
          return; // If tags are already loaded, skip fetching
        } else {
          // const getList = await getAllTags();
          // // console.log("Get All Tags : ", getList);
          // if (getList.data) {
          //   dispatch(setTagsList(getList.data));
          //   setTagsListArray(getList.data);
          // } else {
          //   console.log("Data Not Found");
          // }
        }
      } catch (error) {
        console.log("Error Fetching Tags", error);
      }
    };

    if (tagList?.length === 0 && menusList?.length === 0) {
      fetchTags();
    }
  }, []);

  const getTagName = (tagId) => {
    const tag = tagList?.find((tag) => tag.tag_id === tagId);
    return tag
      ? {
          tag_id: tag.tag_id,
          name: tag.tag_name,
        }
      : {};
  };

  return {
    tagList,
    getTagName,
  };
};

export default useTags;
